import { insertRow } from "./db";

/**
 * Queues a customer receipt. Only the order id is sent: what prints is built server-side (sync-api's
 * printJobsRouter). A missing printer or an offline Hub never affects the sale, and the digital
 * receipt still works.
 */
export async function printReceipt(orderId: string): Promise<void> {
  const now = new Date().toISOString();
  try {
    await insertRow("print_jobs", { id: crypto.randomUUID(), order_id: orderId, created_at: now, updated_at: now });
  } catch (err) {
    console.warn("printReceipt failed (non-fatal):", err);
  }
}

/**
 * Queues a kitchen ticket print job for an already-committed kitchen
 * ticket. Only IDs are
 * sent, the full ticket content (items, notes, table) is re-derived
 * server-side from kitchen_ticket_id (see sync-api's printJobsRouter
 * beforeInsert). order_id is still required alongside it since
 * printing.print_jobs.order_id stays NOT NULL either way.
 */
export async function printKitchenTicket(kitchenTicketId: string, orderId: string): Promise<void> {
  const now = new Date().toISOString();
  try {
    await insertRow("print_jobs", {
      id: crypto.randomUUID(),
      order_id: orderId,
      kitchen_ticket_id: kitchenTicketId,
      created_at: now,
      updated_at: now,
    });
  } catch (err) {
    // Most commonly "no_kitchen_printer_configured" (400) — mirrors
    // a missing printer or offline Print Hub must never affect the send.
    console.warn("printKitchenTicket failed (non-fatal):", err);
  }
}
